import React, { useMemo } from 'react';
import { RichText } from '@shopify/hydrogen-react';
import { Metafield } from '@portal/processes/ShopV2/ShopV2.types';

type Props = {
  metafield: Metafield; // e.g., variant.metafield(...)
  className?: string;
  components?: Record<string, React.ComponentType<any>>; // optional custom renderers
};

const USPRichTextImpl = ({ metafield, className, components }: Props) => {
  const raw = useMemo(() => {
    if (!metafield?.value) return null;
    return typeof metafield.value === 'string' ? metafield.value : JSON.stringify(metafield.value);
  }, [metafield?.value]);

  if (!raw) return null;
  return (
    <div className={className}>
      <RichText data={raw} components={components} />
    </div>
  );
};

/** Memoized: only re-renders when the metafield value or className changes. */
export const USPRichText = React.memo(
  USPRichTextImpl,
  (prev, next) =>
    prev.className === next.className && prev.metafield?.value === next.metafield?.value
);
